export default __webpack_public_path__ + "static/media/import.dfe1e539.svg";